module.exports = __webpack_public_path__ + "static/media/todoReact.a5ff9486.gif";